<template>
  <b-modal
    class="loading-modal"
    no-close-on-backdrop
    :visible="value"
    no-close-on-esc
    hide-footer
    hide-header
    size="sm"
    centered
    busy
    v-bind="{ id }"
    @input="$emit('input', $event)"
  >
    <template slot="modal-header">
      <div>
        <hr class="split-event" />
        <h4 class="modal-title">{{ modalTitle }}</h4>
      </div>
    </template>

    <div class="loading-modal-body" data-cy="loading-modal">
      <div class="loader position-relative text-center p-3">
        <b-spinner variant="primary" class="loading-spinner" :label="$t('cmrad.loading_with_dots')" />
      </div>
      <div class="text-center mt-3">
        <slot>{{ $t('cmrad.loading_with_dots') }}</slot>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import uniqid from 'uniqid';

  export default {
    name: 'LoadingModal',

    props: {
      title: {
        type: String,
        default: 'Loading',
      },
      id: {
        type: String,
        default: () => uniqid('loading-modal-'),
      },
      value: Boolean,
    },

    data() {
      return {
        modalTitle: this.title || this.$t('cmrad.loading_with_dots'),
      };
    },
  };
</script>

<style lang="scss">
  .modal-body {
    .loading-modal-body {
      p {
        text-align: center;
      }

      .loading-spinner {
        width: 5rem;
        height: 5rem;
      }

      .circular {
        -webkit-animation: rotate 2s linear infinite;
        animation: rotate 2s linear infinite;
        height: 10rem;
        -webkit-transform-origin: center center;
        -ms-transform-origin: center center;
        transform-origin: center center;
        width: 10rem;
        margin: auto;
      }
    }
  }
</style>
